/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, { Component } from "react";
import AriaLiveCss from "./AriaLive.css";
import { FormattedMessage } from "react-intl";

class AriaLive extends Component {
  render() {
    return (
      <div className={AriaLiveCss.AriaLive} role="log" aria-live="polite">
        {this.props.message.id ? (
          <FormattedMessage id={this.props.message.id} values={this.props.message.values} />
        ) : (
          ""
        )}
      </div>
    );
  }
}

export { AriaLive };
